<template>
  <tr>
    <td data-label="Name">
      <strong>
        <router-link :to="{ path: company.uuid, append: true }">
          {{ company.name }}
        </router-link>
      </strong>
    </td>
    <td data-label="Address">
      {{ company.postalAddress }}
    </td>
    <td data-label="Phone">
      <a :href="'tel:' + phone">
        {{ company.phone }}
      </a>
    </td>
    <td data-label="Email">
      <a :href="'mailto:' + company.email" target="_top">
        {{ company.email }}
      </a>
    </td>
    <td data-label="Properties">
      {{ company.Properties.length }}
    </td>
    <td class="text-center">
      <dropdown 
        :title="'Company Actions'"
        :icon="'fa fa-briefcase'"
        :actions="companyActions"
        @action="executeAction($event, company)">
      </dropdown>
    </td>
  </tr>
</template>

<script>
  import Dropdown from '@/components/ui/Dropdown'
  import {
    EDIT_COMPANY,
    DELETE_COMPANY,
    EDIT_MASTER_NOTE
  } from '@/vuex/types'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'CompanyRow',
    components: {
      Dropdown
    },
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      phone () {
        if (this.company.phone) {
          return this.company.phone.replace(/\D/g, '')
        } else {
          return ''
        }
      },
      company () {
        return {
          Properties: [],
          ...this.object
        }
      },
      ...mapGetters([
        'companyActions'
      ])
    },
    methods: {
      async executeAction (action, payload) {
        await this[action](payload)
      },
      ...mapActions([
        EDIT_COMPANY,
        EDIT_MASTER_NOTE,
        DELETE_COMPANY
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/Company.vue